import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  selectKeyDatesRelease,
  selectLanesTiers,
  selectSearchFilterActive,
  selectSearchFilteredItems
} from 'app/pages/Home/slice/selectors';
import { flattenReleaseProjects } from '../utils/flattenReleaseProjects';
import type { MonthlyTimelineLane } from '../utils/types';

/**
 * Returns the Key Dates swimlane when the lanes/tiers filter allows it,
 * mirroring quarterly Roadmap.tsx dedicated Key Dates row rendering.
 */
export function useMonthlyKeyDatesLane(): MonthlyTimelineLane | null {
  const keyDatesRelease = useSelector(selectKeyDatesRelease);
  const lanesTiers = useSelector(selectLanesTiers);
  const searchFilterActive = useSelector(selectSearchFilterActive);
  const searchFilteredItems = useSelector(selectSearchFilteredItems);

  return useMemo(() => {
    const shouldShowKeyDates =
      ((searchFilterActive && searchFilteredItems.length > 0) ||
        lanesTiers.selectedLanesTiers.includes('key-dates') ||
        lanesTiers.selectedLanesTiers.includes('all')) &&
      keyDatesRelease;

    if (!shouldShowKeyDates) {
      return null;
    }

    return {
      key: 'key-dates',
      label: 'Key Dates',
      releaseType: 'Key Dates',
      isKeyDate: true,
      items: flattenReleaseProjects(keyDatesRelease)
    };
  }, [
    keyDatesRelease,
    lanesTiers.selectedLanesTiers,
    searchFilterActive,
    searchFilteredItems
  ]);
}
